import React, { useContext } from 'react';

import { Link } from 'react-router';

import { type Company, CompanyContext } from 'common/containers/CompanyContainer';
import { useOnboardingContext } from 'common/containers/OnboardingContainer';
import { SourcesOptionValue } from 'common/subdomain/admin/AdminOnboarding/constants';
import {
  type SourcesOptionValueKey,
  feedbackSources,
} from 'common/subdomain/admin/AdminOnboarding/data';
import OnboardingIntegrationCard from 'common/subdomain/admin/AdminOnboarding/InAppOnboarding/OnboardingIntegrationCard';
import VStack from 'common/ui/VStack';

const OnboardingFeedbackSources = () => {
  const company = useContext(CompanyContext);
  const { onboarding } = useOnboardingContext();

  const selectedSources = onboarding.communicationTools.filter((tool) =>
    Object.values(SourcesOptionValue).includes(tool as any),
  );
  const hasUnselectedSources = Object.values(SourcesOptionValue).some(
    (source) => !selectedSources?.includes(source),
  );

  return (
    <VStack className="gap-4">
      {selectedSources?.map((source) => {
        const integrationID = source as keyof typeof feedbackSources;

        return (
          <OnboardingIntegrationCard
            key={source}
            icon={feedbackSources[integrationID].icon}
            title={feedbackSources[integrationID].label}
            description={feedbackSources[integrationID].description}
            href={feedbackSources[integrationID].url}
            isInstalled={isFeedbackSourceInstalled(integrationID as SourcesOptionValueKey, company)}
            tag={feedbackSources[integrationID].tag}
            installButtonTitle={feedbackSources[integrationID].installButtonTitle}
          />
        );
      })}
      {hasUnselectedSources && (
        <Link to="/admin/settings/integrations/feedback-boards">
          <button className="unstyled-button self-start px-1.5 underline font-medium text-gray-110 text-body">
            Show all sources
          </button>
        </Link>
      )}
    </VStack>
  );
};

const isFeedbackSourceInstalled = (source: SourcesOptionValueKey, company: Company) => {
  return company?.activeIntegrations[source] ?? false;
};

export const isSelectedFeedbackSourcesInstalled = (company: Company) => {
  return Object.keys(feedbackSources).some((source) =>
    isFeedbackSourceInstalled(source as SourcesOptionValueKey, company),
  );
};

export default OnboardingFeedbackSources;
